import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
import Time from "react-time-format";
import { Link } from "react-router-dom";

class ScroollTableParawargrtnawakan extends React.Component {
  render() {
    return (
      <>
        <ProductConsumer>
          {(value) => {
            const { RPW_data, RPW_getParaDataBySearchMoney } = value;
            const qarzeWakel = RPW_data.map((user, i) => {
              return (
                <tr key={i} className="fk f4">
                  <td className="fk" style={{ border: "2px solid #f0ad4e" }}>
                    {user.nawiwargr}
                  </td>
                  <td
                    className="fk"
                    style={{ border: "2px solid #f0ad4e" }}
                    className={`${
                      user.joripara == "دۆلار" ? "text-success" : "text-danger"
                    }`}
                  >
                    {user.joripara}
                  </td>
                  <td className="fk" style={{ border: "2px solid #f0ad4e" }}>
                    <NumberFormat
                      value={
                        user.joripara == "دۆلار"
                          ? user.briparabadolar
                          : user.briparabadinar
                      }
                      thousandSeparator={true}
                      displayType="text"
                    />
                  </td>
                  <td className="fk " style={{ border: "2px solid #f0ad4e" }}>
                    {user.nawikas}
                  </td>
                  <td className="fk" style={{ border: "2px solid #f0ad4e" }}>
                    <Time
                      value={user.date}
                      format="YYYY-MM-DD"
                      style={{ color: "black" }}
                    />
                  </td>
                  <td
                    className="fk"
                    style={{ border: "2px solid #f0ad4e", cursor: "pointer" }}
                    onClick={(e) =>
                      RPW_getParaDataBySearchMoney(e, user.zhmara)
                    }
                  >
                    <Link to="/parawargrtn">{user.zhmara}</Link>
                  </td>
                </tr>
              );
            });

            return (
              <div className="JM">
                <table
                  id="example"
                  className="table table-hover table-bordered text-right"
                >
                  <thead>
                    <tr
                      className="text-warning f4"
                      style={{ backgroundColor: "#2C3539" }}
                    >
                      <th style={{ border: "2px solid #f0ad4e" }}>
                        ناوی وەرگر
                      </th>
                      <th style={{ border: "2px solid #f0ad4e" }}>دراو</th>
                      <th style={{ border: "2px solid #f0ad4e" }}>
                        کۆی پسوولە
                      </th>
                      <th style={{ border: "2px solid #f0ad4e" }}>ناوی کەس</th>
                      <th style={{ border: "2px solid #f0ad4e" }}>بەروار</th>
                      <th style={{ border: "2px solid #f0ad4e" }}>ژمارە</th>
                    </tr>
                  </thead>
                  <tbody>{qarzeWakel}</tbody>
                </table>
              </div>
            );
          }}
        </ProductConsumer>
      </>
    );
  }
}
export default ScroollTableParawargrtnawakan;
